import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import i18next from '@/helpers/i18n';

dayjs.extend(relativeTime);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const updateDayjsLocale = () => {
  const currentLocale = i18next.resolvedLanguage || 'en';

  dayjs.updateLocale(
    currentLocale,
    i18next.t('common:dayjs', {
      returnObjects: true,
    })
  );
};

if (i18next.isInitialized) {
  updateDayjsLocale();
} else {
  i18next.on('initialized', updateDayjsLocale);
}

i18next.on('languageChanged', updateDayjsLocale);

export default dayjs;
